export enum AppDefaultTaskViewType {
  All = "All",
  Today = "Today"
}
